<template>
	<div class="main page automations-page layout-column" :class="isWorkflowOpen?'noscroll':'scroll'">
		<div class="layout-row flex" :class="isWorkflowOpen?'noscroll':''">

			<div class="left-tabs-wrapper">
				<div class="left-tabs">
					<h3>Automations</h3>
					<div class="layout-column">
						<ul class="left-tabs-items">
							<li>
								<router-link to="/automations" class="item " >
									<span>All automations </span>
								</router-link>
							</li>
							<div class="v-sep"></div>
							<li>
								<router-link to="/automations/archive" class="item " >
									<inline-svg :src="require('@/assets/img/archive.svg')" />
									<span>Archive</span>
								</router-link>
							</li>
						</ul>
					</div>
				</div>
			</div>

			<div class="page-content noscroll" >
				<router-view/>
			</div>

		</div>
	</div>

</template>

<script>
import VButton from "@/components/base/v-button";
import NewAutomationPopup from "@/views/automations/new-automation-popup";
import {is} from "@/helpers/roles";

export default {
    name: "automations",
    components: {
	    NewAutomationPopup,
	    VButton,
    },
    data: function() {
        return {
        	newPopupOpen: false,
          loading: true,
        };
    },
    computed: {
			isWorkflowOpen() {
				return !!this.$route.meta.is_workflow
			}
    },
    methods: {
	    is(role){
		    return is(role);
	    },
    },
    created() {
    }
}
</script>

<style lang="scss" scoped>
.automations-page {

}
.entry {
	min-height: 30px;
	padding: 0 10px;
	.panel_item_right, .panel_item_left {
		padding: 3px 0;
	}
	.panel_item_btn {
		min-width: 34px;
		min-height: 34px;
		width: 34px;
		height: 34px;
		svg {
			//height: 18px;
			//width: 18px;
		}
	}
}
.automations_item_img {
	color: $blue;
	margin-right: 5px;
	svg {
		opacity: .7;
		height: 24px;
	}
}
</style>
